import { Component, OnInit } from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';
import {SchoolService} from "../../services/school.service";
import {MainService} from "../../services/main.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-school',
  templateUrl: './school.component.html',
  styleUrls: ['./school.component.css', './mobile.style.css']
})
export class SchoolComponent implements OnInit {

	public carouselOne: NgxCarousel;

  isLoaded:boolean = false;
  theSchool:any;
  thePage:any;
  title:any;
  content:any;
  nodisplay:boolean = false;
  constructor(
      private sService: SchoolService,
      private route: ActivatedRoute,
      private router: Router,
      private ms:MainService
    ) { }

  management:boolean;
  biotech:boolean;
  engineering:boolean;
  ict:boolean;
  buddhism:boolean;
  vocational:boolean;
  humanities:boolean;
  law:boolean;


  theNotice:any;
  theGallery:any;
  isGallery:boolean = false;



  schoolReset(){
    this.management = false;
    this.biotech = false;
    this.engineering = false;
    this.ict = false;
    this.buddhism = false;
    this.vocational = false;
    this.humanities = false;
    this.law = false;
  }


  allGallery:any = {
    "management":[
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_125.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_126.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_127.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_128.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-06%202235PM_SOM_pic1.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-06%202235PM_SOM_pic2.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-06%202235PM_SOM_pic3.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-06%202235PM_SOM_pic4.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-06%202235PM_SOM_pic5.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-06%202235PM_SOM_pic6.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-06%202236PM_SOM_pic7.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-06%202236PM_SOM_pic8.jpg"
      }
    ],
    "biotech":[
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2017-12-18%202220PM_Bio_lecture_pic1.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2017-12-18%202220PM_Bio_lecture_pic2.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2017-12-18%202221PM_Bio_lecture_pic3.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2017-12-18%202221PM_Bio_lecture_pic4.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2017-12-18%202221PM_Bio_lecture_pic5.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2013-09-20%200352AM_SOB_Pic1.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/PICTURE%20NO%20076.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_64.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_66.JPG"
      }
    ],
    "engineering":[
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200042AM_EcoDesign_Inauguration%2001.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200043AM_EcoDesign_Inaugral%20function1.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200043AM_EcoDesign_Inaugration%20photo2.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200044AM_EcoDesign_inaugration%20phot3.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200045AM_EcoDesign_photo%20banner.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200045AM_EcoDesign_image10.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200045AM_EcoDesign_image11.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200046AM_EcoDesign_image13.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200047AM_EcoDesign_image12.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-10-16%200048AM_EcoDesign_image9.JPG"
      },      
    ],
    "ict":[
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/PICTURE%20NO%20214.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/PICTURE%20NO%20215.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_77.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_78.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_92.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_103.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_110.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_111.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_112.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/SchoolPhotoGallery/SmallPhoto_116.JPG"
      }
    ],
    "buddhism":[
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200307AM_pic%201.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200308AM_pic%202.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200308AM_pic3.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200308AM_pic4.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200309AM_pic5.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200309AM_pic6.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200309AM_pic7.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200309AM_pic8.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2016-01-19%200309AM_pic9.jpg"
      },
    ],
    "vocational":[
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-09%202330PM_Dr.%20Rajesh%20Gupta%20IYBA.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200314AM_DSC_6897.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200314AM_DSC_6949.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200315AM_DSC_6964.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200316AM_DSC_6948.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200317AM_DSC_7114.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200317AM_DSC_6846.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200318AM_DSC_6888.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200320AM_DSC_6936.JPG"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-01-31%200321AM_DSC_6970.JPG"
      },
    ],
    "humanities":[
    ],
    "law":[
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-03-18%202302PM_2012-09-22%2009.29.07.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-03-18%202303PM_1231514_10201509836259160_1128417248_n.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-03-18%202303PM_BA%20LLB%20Students.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-03-18%202306PM_IMAG0657.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-03-18%202308PM_IMAG0669.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-03-18%202309PM_IMAG0671.jpg"
      },
      {
        "caption": "",
        "img": "http://www.gbu.ac.in/Admin_Pages/SchoolImages/2014-03-18%202311PM_IMAG0673.jpg"
      },
    ]
  }

  allNotice:any = {
    "management":{
      "news":[
        {
          "id":1,
          "content": "Orientation 2018, Date: 3 October 2018 at SOM",
          "link": "http://www.gbu.ac.in/SOM/Orientation%20programme_3Oct18.pdf"
        }
      ],
      "event":[           
        {
          "id":1,
          "content": "MDP on Competing Corporate Competencies ‘CCC’ 2018, Date: 8th February 2018 at SOM",
          "link": "http://www.gbu.ac.in/Events/SOM_MDPbrochure_24Jan2018.pdf"
        },
        {
          "id":2,
          "content": " Workshop on Entrepreneurship Development Programme (EDP), Date: 2nd February 2018 at SOM",
          "link": "http://www.gbu.ac.in/Events/SOM_EDP%20poster_31Jan18.pdf"
        },
        {
          "id":3,
          "content": " 2nd International Conferences on Advances in Management & Decision Sciences (July 2016) ",
          "link": "http://www.gbu.ac.in/SOM/SOM_AdvancesManagementDecisionSciences_25July2016.pdf"
        },
        {
          "id":4,
          "content": " Orientation Program 2016-17 at SOM",
          "link": "http://www.gbu.ac.in/SOM/Orientation%20Report_6Sept2016.pdf"
        },
        {
          "id":5,
          "content": " International Conferences on Advances in Management & Decision Sciences",
          "link": "http://www.gbu.ac.in/SOM/International%20Conference%20July2015_21March%202016.pdf"
        }
      ],
      "notice":[
      ]
    },
    "biotech":{
      "news":[
      {
          "id":1,
          "content": "Industrial Visit of Biotechnology Students to Yakult Danone Pvt. Ltd. Sonipat",
          "link": "http://www.gbu.ac.in/SOB/IndustrialVisit_Biotech_Yakult Danon_16Nov18.pdf"
        },
        {
          "id":2,
          "content": " Parents Meeting Calendar",
          "link": "http://www.gbu.ac.in/SOB/SoBt_Parentsmeetings_9Feb18.pdf"
        },
        {
          "id":3,
          "content": "“SoBT organized two-days National Workshop on “Environmental Restoration by Applying Metagenomics in Bioremediation” in collaboration with Chaperon Biotech Pvt. Ltd on 19-20 January 2018”",
          "link": "http://www.gbu.ac.in/SOB/SOBt_Bioremediation_31Jan18.pdf"
        },
        {
          "id":4,
          "content": " SoBT organized invited Lectures on 20th Nov 2017",
          "link": "http://www.gbu.ac.in/SOB/SOB_Final_LecturePhotowebsite_19Dec2017.pdf"
        }
      ],
      "event":[
        {
          "id":1,
          "content": "National Conference on Translational Research in Biotechnology: Current and Future Perspectives on 9th November 2019",
          "link": "http://www.gbu.ac.in/notice/213"
        },
      {
          "id":2,
          "content": " University-Industry Research Round Table, 22 November  2018, organized by School of Biotechnology   ",
          "link": "http://www.gbu.ac.in/SOB/SoBT_UIRRT- Information Brochure_14Nov18.pdf"
        },
        {
          "id":3,
          "content": " 1st ALUMNI Meet In School Of Biotechnology On 27th April, 2017 ",
          "link": "http://www.gbu.ac.in/Events/SOBT_Event_AlumniMeet2017_26April2017.pdf"
        },
        {
          "id":4,
          "content": " National Conference on “Development and advancement in conservation, propagation and sustainable utilization of medicinal plants (DSUMP 2017)” funded by Minist",
          "link": "http://www.gbu.ac.in/SOB/SOBT_DSUMP_31Jan18.pdf"
        },
        {
          "id":5,
          "content": "Invited lectures by Dr. Rajendra K. Pachauri (World renowned environmentalist) andMr. Dinesh Jain (UFLEX) – 20th November 2017",
          "link": "#"
        },
        {
          "id":6,
          "content": " “SoBT organized two-days National Workshop on “Environmental Restoration by Applying Metagenomics in Bioremediation”",
          "link": "http://www.gbu.ac.in/SOB/SOBt_Bioremediation_31Jan18.pdf"
        },

      ],
      "notice":[
        {
          "id":1,
          "content": "SoBT, GBU has a three year academic membership subscription with Association of Biotechnology Led Enterprises (ABLE, India) (2016-2019)",
          "link": "#"
        },
        {
          "id":1,
          "content": "MoU signed between GBU, Greater Noida and ICAR-NBAGR, Karnal (2013-2017) for facilitating PhD research work",
          "link": "#"
        },
        {
          "id":1,
          "content": "MoU signed between GBU, Greater Noida and CSIR-IIMR, Pusa, New Delhi, for five years (2016-2012) for joint research and facilitation for students to carry out dissertation/PhD research work",
          "link": "#"
        }
      ]
    },
    "engineering":{
      "news":[
        {
          "id":1,
          "content": " Spectrum : A Techno Creative Newsletter For SOE",
          "link": "http://www.gbu.ac.in/SOE/SOE_Newsletter15_16March2016.pdf"
        },
        {
          "id":1,
          "content": "Engineers Day and Hindi Diwas, 2015 Report ",
          "link": "http://www.gbu.ac.in/SOE/EnggDay_Hindidiwas_9Sept2015.pdf"
        },
        {
          "id":1,
          "content": "Hindi Diwas and Engineers Day Report",
          "link": "http://www.gbu.ac.in/SOE/SOE_EnggsDay_31Oct14.pdf"
        },
        {
          "id":1,
          "content": "Achievements of Mechanical Engineering Students",
          "link": "http://www.gbu.ac.in/SOE/SOE_Achievements_MTech_Mechanical_29Oct14.pdf"
        },
        {
          "id": 5,
          "content": "Inspection from Council of Architecture (CoA) 2018 Department of Architecture and Planning",
          "link": "http://www.gbu.ac.in/SOE/DeptArch_CoAInspection_22Sept2018.pdf"
        }

      ],
      "event":[
      {
          "id":1,
          "content": "Departmental Activities of Electrical Engg.",
          "link": "http://www.gbu.ac.in/SOE/SOE_ElectricalDepartmental%20Activities_1Feb18.pdf"
        },
        {
          "id":1,
          "content": "FDP Media Coverage on Urban Informatics: Dr. Mehrotra, Department of Architecture, SOE",
          "link": "http://www.gbu.ac.in/SOE/SOA_FDP Media Coverage_23March19.pdf"
        },
        {
          "id":1,
          "content": "NANOfIM 2017 IEEE International Conference",
          "link": "http://nanofim.gbu.co.in/"
        },
        {
          "id":1,
          "content": "World Architecture Day 2016-17 at SOA",
          "link": "http://www.gbu.ac.in/SOE/SOA_WorldArchDay_14Oct2016.jpg"
        },
        {
          "id":1,
          "content": "Engineers Day and Hindi Diwas, 2015 Report",
          "link": "http://www.gbu.ac.in/SOE/EnggDay_Hindidiwas_9Sept2015.pdf"
        },
        {
          "id":1,
          "content": "  ECO Design Fair 2015 ",
          "link": "http://www.gbu.ac.in/SOE/EcoDesignFair_4Nov2015.jpg"
        },

      ],
      "notice":[
      ]
    },
    "ict":{
      "news":[
      ],
      "event":[
      ],
      "notice":[
      ]
    },
    "buddhism":{
      "news":[
        {
          "id":1,
          "content": "International Conference on Buddhism: Traditions, Ideologies and Dissent to be held from 7th to 9th September 2017 Call For Paper",
          "link": "http://www.gbu.ac.in/SOBSC/Conference_BuddhismTraditionsIdeologies_CallPapers7July2017.jpg"
        },
        {
          "id":1,
          "content": "International Conference on Buddhism: Traditions, Ideologies and Dissent to be held from 7th to 9th September 2017 Information Leaf",
          "link": "http://www.gbu.ac.in/SOBSC/Conference_BuddhismTraditionsIdeologies_InformationLeaf_7July2017.jpg"
        },
      ],
      "event":[
      ],
      "notice":[
      ]
    },
    "vocational":{
      "news":[
        {
          "id":1,
          "content": " Ph.D. Chemistry Research Scholar achieved first prize in International Workshop",
          "link": "http://www.gbu.ac.in/UniversityDoc/SOVSAS_ResearchScholar_Information_25Nov14.pdf"
        },
      ],
      "event":[
        {
          "id":1,
          "content": "Workshop on “Learning Electromagnetic Theory through Problem Solving, Numerical Simulation and Lab Experiments”",
          "link": "http://www.gbu.ac.in/SOA/SOVSAS_WorkshopElectromagnetictheory_20March18.jpg"
        },
      ],
      "notice":[
        {
          "id":1,
          "content": "Ph.D. Chemistry Research Scholar achieved first prize in International Workshop",
          "link": "http://www.gbu.ac.in/UniversityDoc/SOVSAS_ResearchScholar_Information_25Nov14.pdf"
        },
      ]
    },
    "humanities":{
      "news":[
        {
          "id":1,
          "content": "44th NACIACP-2018 in the Department of Psychology & Mental Health, SOHSS, 23-25 Feb., 2018",
          "link": "http://www.gbu.ac.in/SOHSSProfile/44thNACIACP_BROCHURE%20_6Dec2017.pdf"
        },
        {
          "id":1,
          "content": "Recognition Order from National Council for Teacher Education",
          "link": "http://www.gbu.ac.in/SOHSSProfile/Deppt_Education_NCT_17May2017.pdf"
        },
      ],
      "event":[
      ],
      "notice":[
         {
             "id":1,
          "content": "National Seminar on Indic Perspective on International Relations in 1st & 2nd February 2019",
          "link": "http://www.gbu.ac.in/SOHSSProfile/National Seminar Brouchure_internationalRelations_26Dec18.pdf"
         }
      ]
    },
    "law":{
      "news":[
        {
          "id":1,
          "content": " PPT of School of Law for UGC",
          "link": "http://www.gbu.ac.in/SOL/SoLaw_PPtUGC_15Feb18.pdf"
        },
        {
          "id":1,
          "content": "Invitation for Expert Lecture on “Salient Features of Indian Constitution” on 9th March 2016",
          "link": "http://www.gbu.ac.in/UniversityDoc/SOLJG_invitationLecture_8March2016.jpg"
        },
        {
          "id":1,
          "content": "Bar Council of India Approval Letter",
          "link": "http://www.gbu.ac.in/UniversityDoc/Bar_Council_India_Approval_Letter1_5Aug13.jpg"
        },
        {
          "id":1,
          "content": "Legal Aid Clinic",
          "link": "http://www.gbu.ac.in/UniversityDoc/Law-Legal-Aid-Clinic.pdf"
        }

      ],
      "event":[
      ],
      "notice":[
      ]
    }
  }



  toDisplayNotice:boolean = false;


  theBullitien:any;


  ngOnInit() {
  	this.carouselOne = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    }

    this.theSchool = this.route.snapshot.paramMap.get('school');
    this.route.params.subscribe( params => {
      this.isLoaded = false;
      this.ms.scrollToTop(500);
      this.theSchool = params.school;

      if (this.theSchool == "management"){
        this.schoolReset()
        this.management = true;
        this.theGallery = this.allGallery.management;
      }
      if (this.theSchool == "biotech"){
        this.schoolReset()
        this.biotech = true;
        this.theGallery = this.allGallery.biotech;
      }
      if (this.theSchool == "engineering"){
        this.schoolReset()
        this.engineering = true;
        this.theGallery = this.allGallery.engineering;
      }
      if (this.theSchool == "ict"){
        this.schoolReset()
        this.ict = true;
        this.theGallery = this.allGallery.ict;
      }
      if (this.theSchool == "buddhism"){
        this.schoolReset()
        this.buddhism = true;
        this.theGallery = this.allGallery.buddhism;
      }
      if (this.theSchool == "vocational"){
        this.schoolReset()
        this.vocational = true;
        this.theGallery = this.allGallery.vocational;
      }
      if (this.theSchool == "humanities"){
        this.schoolReset()
        this.humanities = true;
        this.theGallery = this.allGallery.humanities;
      }
      if (this.theSchool == "law"){
        this.schoolReset()
        this.law = true;
        this.theGallery = this.allGallery.law;
      }
      this.thePage = params.content;
      this.sService.getContent(this.theSchool, this.thePage).subscribe((result:any)=>{
        this.title = result.title;
        this.content = result.content;
        this.isLoaded = true;
        console.log(this.thePage);
        if (this.thePage == undefined || this.thePage == 'home') {
          console.log("Vishal is great");
          this.toDisplayNotice = true;
          if (this.theSchool == "management"){
            
            this.theBullitien = this.allNotice.management;
          }
          if (this.theSchool == "biotech"){
            this.theBullitien = this.allNotice.biotech;
          }
          if (this.theSchool == "engineering"){
            this.theBullitien = this.allNotice.engineering;
          }
          if (this.theSchool == "ict"){
            this.theBullitien = this.allNotice.ict;
          }
          if (this.theSchool == "buddhism"){
            this.theBullitien = this.allNotice.buddhism;
          }
          if (this.theSchool == "vocational"){
            this.theBullitien = this.allNotice.vocational;
          }
          if (this.theSchool == "humanities"){
            this.theBullitien = this.allNotice.humanities;
          }
          if (this.theSchool == "law"){
            this.theBullitien = this.allNotice.law;
          }

        }
        else{
          this.toDisplayNotice = false;
        }

        if (this.thePage == 'photogallery') {
          this.isGallery = true;
        }
        else{
          this.isGallery = false;
        }
      });
    });

    
     
  }

}



// WEBPACK FOOTER //
// ./src/app/components/school/school.component.ts